import { en } from "./translations.en";
import { fr } from "./translations.fr";
import { pt } from "./translations.pt";

export const translations = {
  en: {
    wallet: en,
  },
  fr: {
    wallet: fr,
  },
  pt: {
    wallet: pt,
  },
};
